import { render, staticRenderFns } from "./TemplateTextEditAreaComponent.vue?vue&type=template&id=bbdbb7ac&scoped=true&"
import script from "./TemplateTextEditAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateTextEditAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdbb7ac",
  null
  
)

export default component.exports